// jshint esversion: 6
if($('.notification-bar').length) {
    $('.close-notification').click(function() {
        // Close Notification
        $('.notification-bar').slideToggle();
        // Set Cookie
        var cookie = $('.notification-bar').attr('data-cookie'),
            unique = $('.notification-bar').attr('data-unique');
        // Check if set
        if(typeof cookie !== typeof undefined && cookie !== false) {
            // Set Cookie for 1 year
            Cookies.set(unique, cookie, { expires: 365 });
        }
    })

    // If Cookie is enabled but close is not
    if($('.close-notification').length == 0) {
        // Set Cookie
        var cookie = $('.notification-bar').attr('data-cookie'),
            unique = $('.notification-bar').attr('data-unique');

        // Check if set
        if(typeof cookie !== typeof undefined && cookie !== false) {

            // Set Cookie for 1 year
            Cookies.set(unique, 'cookie-' + cookie, { expires: 365 });
        }
    }
}

if($('.notification-popup').length) {
    $('.notification-popup').foundation('toggle');

    // Set Cookie
    var cookie = $('.notification-popup').attr('data-cookie'),
        unique = $('.notification-popup').attr('data-unique');

    // Check if set
    if(typeof cookie !== typeof undefined && cookie !== false) {

        // Set Cookie for 1 year
        Cookies.set(unique, 'cookie-' + cookie, { expires: 365 });
    }

}
